export const messages = {
    en: {
      adminIndex: {
        home: 'Home',
        platformData: 'Platform Data',
        paymentCount: 'Payment Count',
        paymentAmount: 'Payment Amount',
        repairCount: 'Repair Count',
        communityFeeStats: 'Community Fee Statistics',
        communityRepairStats: 'Community Repair Statistics'
      },
      propertyIndex: {
        home: 'Home',
        dashboard: 'Dashboard',
        communityInfo: 'Community Information',
        building: 'Building',
        house: 'House',
        shop: 'Shop',
        parkingSpace: 'Parking Space',
        residentReg: 'Resident Registration',
        registerResident: 'Register Resident',
        vehicle: 'Vehicle',
        viewVehicle: 'View Vehicles',
        unit: 'unit',
        ownerFeedback: 'Owner Feedback',
        noFeedback: 'No feedback content currently',
        feedback: 'feedback',
        completed: 'Completed',
        followingUp: 'Following up',
        transferRepair: 'Transferred to repair order',
        repairStats: 'Repair Statistics',
        allRepair: 'All Repairs',
        toBeDispatched: 'To be dispatched',
        processing: 'Processing',
        processed: 'Processed',
        complaintStats: 'Complaint Statistics',
        allComplaint: 'All Complaints',
        repairInfo: 'Repair Info',
        unprocessed: 'Unprocessed',
        residentRegStats: 'Resident Registration Statistics',
        unregistered: 'Unregistered',
        registered: 'Registered',
        unboundRoom: 'Unbound Room',
        boundRoom: 'Bound Room',
        residentInfo: 'Resident Info',
        feeDashboard: 'Fee Dashboard',
        propertyFee: 'Property Fee',
        historyOweFee: 'Historical Arrears',
        electricFee: 'Electricity Fee',
        waterFee: 'Water Fee',
        multiBusinessFee: 'Business Fees',
        parkingMonthlyFee: 'Parking Monthly Fee',
        todayReceived: 'Received Today',
        receivable: 'Receivable',
         unreceived: 'Unreceived'
         ,receivablePercent: 'Receivable share'
      }
    },
    zh: {
      adminIndex: {
        home: '首页',
        platformData: '平台数据',
        paymentCount: '缴费数',
        paymentAmount: '缴费金额',
        repairCount: '报修单数',
        communityFeeStats: '小区缴费统计',
        communityRepairStats: '小区报修统计'
      },
      propertyIndex: {
        home: '首页',
        dashboard: '控制台',
        communityInfo: '小区信息',
        building: '楼宇',
        house: '房屋',
        shop: '商铺',
        parkingSpace: '车位',
        residentReg: '住户登记',
        registerResident: '登记住户',
        vehicle: '车辆',
        viewVehicle: '查看车辆',
        unit: '个',
        ownerFeedback: '业主反馈',
        noFeedback: '当前没有业主反馈内容',
        feedback: '反馈',
        completed: '完成',
        followingUp: '跟进中',
        transferRepair: '已转报修单',
        repairStats: '报修统计',
        allRepair: '全部报修',
        toBeDispatched: '待派单',
        processing: '处理中',
        processed: '已处理',
        complaintStats: '投诉统计',
        allComplaint: '全部投诉',
        repairInfo: '报修信息',
        unprocessed: '未处理',
        residentRegStats: '住户注册统计',
        unregistered: '未注册',
        registered: '已注册',
        unboundRoom: '未绑定房屋',
        boundRoom: '已绑定房屋',
        residentInfo: '住户信息',
        feeDashboard: '收费看板',
        propertyFee: '物业费',
        historyOweFee: '历史欠费',
        electricFee: '电费',
        waterFee: '水费',
        multiBusinessFee: '多项经营费',
        parkingMonthlyFee: '车位包月费',
        todayReceived: '当日已收',
        receivable: '应收',
         unreceived: '未收'
         ,receivablePercent: '应收占比'
      }
    },
    'zh-TW': {
      adminIndex: {
        home: '首頁',
        platformData: '平台數據',
        paymentCount: '繳費數',
        paymentAmount: '繳費金額',
        repairCount: '報修單數',
        communityFeeStats: '小區繳費統計',
        communityRepairStats: '小區報修統計'
      },
      propertyIndex: {
        home: '首頁',
        dashboard: '控制台',
        communityInfo: '小區信息',
        building: '樓宇',
        house: '房屋',
        shop: '商鋪',
        parkingSpace: '車位',
        residentReg: '住戶登記',
        registerResident: '登記住戶',
        vehicle: '車輛',
        viewVehicle: '查看車輛',
        unit: '個',
        ownerFeedback: '業主反饋',
        noFeedback: '當前沒有業主反饋內容',
        feedback: '反饋',
        completed: '完成',
        followingUp: '跟進中',
        transferRepair: '已轉報修單',
        repairStats: '報修統計',
        allRepair: '全部報修',
        toBeDispatched: '待派單',
        processing: '處理中',
        processed: '已處理',
        complaintStats: '投訴統計',
        allComplaint: '全部投訴',
        repairInfo: '報修信息',
        unprocessed: '未處理',
        residentRegStats: '住戶注冊統計',
        unregistered: '未注冊',
        registered: '已注冊',
        unboundRoom: '未綁定房屋',
        boundRoom: '已綁定房屋',
        residentInfo: '住戶信息',
        feeDashboard: '收費看板',
        propertyFee: '物業費',
        historyOweFee: '歷史欠費',
        electricFee: '電費',
        waterFee: '水費',
        multiBusinessFee: '多項經營費',
        parkingMonthlyFee: '車位包月費',
        todayReceived: '當日已收',
        receivable: '應收',
         unreceived: '未收'
         ,receivablePercent: '應收占比'
      }
    }
  }
